import { styled } from 'Theme'

export const StyledList = styled.div`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  color: ${({ theme }): string => theme.colors.primary};
  cursor: default;
`
